import { PencilIcon, StarIcon, TrashIcon } from "lucide-react";
import { HttpRequest } from "../../../services/httpRequest";

export const formatAmount = (payValue) => {
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  let parsedAmount = USDollar.format(payValue).split(".")[0];
  return parsedAmount;
};

export const optionsMenuEllipsis = [
  {
    name: "creditDetails",
    text: "Ver detalle de mi crédito",
    href: "/detalle-credito",
  },
  {
    name: "payCredit",
    text: "Pagar mi cuota",
    href: "/pagar",
  },
  {
    name: "renewCredit",
    text: "Consultar cupo",
    href: "/renovar",
  },
];

export const optionsBankActions = [
  {
    name: "Principal",
    text: "Cambiar a principal",
    action: "mainAccount",
    icon: <StarIcon size={10} />,
  },
  {
    name: "Editar",
    text: "Editar Banco",
    action: "editAccount",
    icon: <PencilIcon size={10} />,
  },
  {
    name: "Eliminar",
    text: "Eliminar Banco",
    action: "deleteAccount",
    icon: <TrashIcon size={10} />,
  },
];

export const determinaCreditoAMostrar = (credits = []) => {
  let vigente = credits.filter((credit) => credit.status === "Vigente");
  let cancelado = credits.filter((credit) => credit.status === "Cancelado");
  let enMora = credits.filter((credit) => credit.status === "En mora");
  let pendienteFirma = credits.filter(
    (credit) => credit.status === "Pendiente de firmar",
  );
  let solRechazada = credits.filter(
    (credit) => credit.status === "Solicitud rechazada",
  );
  let sinEstado = credits.filter((credit) => credit.status === "");

  if (vigente.length > 0) {
    return vigente;
  } else if (cancelado.length > 0) {
    return cancelado;
  } else if (enMora.length > 0) {
    return enMora;
  } else if (pendienteFirma.length > 0) {
    return pendienteFirma;
  } else if (solRechazada.length > 0) {
    return solRechazada;
  } else if (sinEstado.length > 0) {
    return sinEstado;
  }
};

export const loadCredits = async () => {
  try {
    const data = await HttpRequest.getAllCreditUser(
      localStorage.getItem("doc"),
    );
    return data.message.info;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const formatFecha = (fechaString) => {
  if (!fechaString) return "";

  const [day, month, year] = fechaString.split("/");
  const fecha = new Date(year, month - 1, day);

  return fecha
    .toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    .replace(".", "");
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return "";
};
